import { Component, inject, signal } from '@angular/core';
import { CategoryApiService } from '@/core';
import { CacButtonComponent, CacFormBuilderComponent, formBuilder, ItemRecord } from '@controladad/ng-base';
import { formControl } from '@al00x/forms';
import { BehaviorSubject, map } from 'rxjs';

@Component({
  selector: 'app-categories-on-home',
  standalone: true,
  imports: [CacFormBuilderComponent, CacButtonComponent],
  templateUrl: './categories-on-home.component.html',
  styleUrl: './categories-on-home.component.scss',
})
export class CategoriesOnHomeComponent {
  private readonly categoryApi = inject(CategoryApiService);

  categories$ = new BehaviorSubject<ItemRecord<number>[]>([]);

  form = formBuilder({
    cols: 2,
    inputs: {
      firstCategory: {
        control: formControl<number | null>(null),
        label: 'First Category',
        type: 'select',
        items: this.categories$,
      },
      secondCategory: {
        control: formControl<number | null>(null),
        label: 'Second Category',
        type: 'select',
        items: this.categories$,
      },
    },
    onInit: () => {
      this.categoryApi.getAll().subscribe((categories) => {
        this.categories$.next(
          categories.map((category) => ({
            label: category.name,
            value: category.id,
          })),
        );
      });
    },
  });

  isLoading = signal(false);

  loadCategoriesOnHome() {
    this.categoryApi.getCategoriesOnHome().subscribe((categories) => {
      this.form.patchValue({
        firstCategory: categories.categories[0]?.id,
        secondCategory: categories.categories[1]?.id,
      });
    });
  }

  onSave() {
    const categoryIds = [this.form.controls.firstCategory.value, this.form.controls.secondCategory.value].filter(
      (id) => typeof id === 'number',
    );

    const model = {
      categoryIds,
    };

    this.isLoading.set(true);

    this.categoryApi.editCategoriesOnHome(model).subscribe(() => {
      this.categoryApi.getCategoriesOnHome().subscribe((categories) => {
        this.loadCategoriesOnHome();
        this.isLoading.set(false);
      });
    });
  }

  constructor() {
    this.loadCategoriesOnHome();
  }
}
